import { createContext } from 'react';

const PickAndPackContext = createContext();

export default PickAndPackContext;